import { JmApi } from "../jm-api/jm-api";
import { DataInstance } from "./data-instance";

export class Shift extends DataInstance {
  private static BASE_URL: string =
    import.meta.env.VITE_CLEVERREACH_API_BASE_URL + "/jmapi/v1/shifts";
  private data: { name: string; start: string; end: string };
  protected id: number | undefined = undefined;
  private officeId: number | undefined = undefined;

  constructor(
    name: string,
    start: string,
    end: string,
    officeId: number,
    id: number | undefined = undefined,
  ) {
    super();
    this.data = {
      name: name,
      start: start,
      end: end,
    };
    this.id = id;
    this.officeId = officeId;
  }

  static getUrlBuilder(officeId: number | undefined = undefined): string {
    if (officeId) {
      return `${Shift.BASE_URL}?officeId=${officeId}`;
    } else {
      return Shift.BASE_URL;
    }
  }

  static deleteUrlBuilder(shiftId: number): string {
    return `${Shift.BASE_URL}?ShiftId=${shiftId}`;
  }

  static postUrlBuilder(officeId: number): string {
    return `${Shift.BASE_URL}?officeId=${officeId}`;
  }

  static putUrlBuilder(shiftId: number): string {
    return `${Shift.BASE_URL}?ShiftId=${shiftId}`;
  }

  get currentData(): object {
    return this.data;
  }

  get currentId(): number | undefined {
    return this.id;
  }

  set currentId(id: number | undefined) {
    this.id = id;
  }

  static fromObject(o: object): Shift | null {
    if (o["name"] && o["start"] && o["end"] && o["office_id"]) {
      return new Shift(o["name"], o["start"], o["end"], o["office_id"]);
    } else {
      return null;
    }
  }

  post(chain: boolean = false): Promise<string> {
    return new Promise((resolve, reject) => {
      if (this.officeId) {
        JmApi.post(Shift.postUrlBuilder(this.officeId), this.data)
          .then((response) => {
            if (chain) {
              resolve("post successful");
            }
          })
          .catch((response) => {
            if (chain) {
              reject("post unsuccessful");
            }
          });
      } else {
        throw new Error("no office id given");
      }
    });
  }
}
